export enum Section14UrgencyTab {
  all = 'all',
  upcoming = 'upcoming',
  late = 'late'
}

export enum Section14HeaderKeys {
  clientName = 'clientName',
  feeRenewalDate = 'feeRenewalDate'
}

export enum MyPracticeToggleTabsKeys {
  practiceManagement = 'practiceManagement',
  futureTab1 = 'futureTab1',
  futureTab2 = 'futureTab2',
  futureTab3 = 'futureTab3'
}

export enum Section14NegativeJourneyCategory {
  search,
  filter,
}